import httpClient from './httpClient'

export type UserNotification = {
    id: string
    type: string
    title: string
    message: string
    entityType: string | null
    entityId: string | null
    packageId: string | null
    linkPath: string | null
    read: boolean
    createdAt: string
}

const PREFIX = 'catalog/api/notifications'

export async function getNotifications(page = 0, size = 20) {
    const { data } = await httpClient.get(`${PREFIX}?page=${page}&size=${size}`)
    return data
}

export async function getUnreadNotificationCount(): Promise<number> {
    const { data } = await httpClient.get<{ count: number }>(`${PREFIX}/unread-count`)
    return data?.count ?? 0
}

export async function markNotificationRead(notificationId: string) {
    await httpClient.put(`${PREFIX}/${notificationId}/read`)
}

export async function markAllNotificationsRead() {
    await httpClient.put(`${PREFIX}/read-all`)
}
